import {useEffect, useState} from "react";
import baseUrl from "../../../../../baseUrl";
import {requester} from "../../../../../services/requester";


const totalArea = (areaInitialInfo, areaDeals, areaOthers, areaDrawings) => {


    let area = 0;
    if (areaInitialInfo.suitable_land) {
        area = area + areaInitialInfo.suitable_land
    }
    if (areaDeals.sum_deals) {
        area = area + areaDeals.sum_deals
    }

    if (areaOthers.total) {
        area = area + areaOthers.total
    }

    if (areaDrawings.sum_drawings) {
        area = area - areaDrawings.sum_drawings
    }

    return area.toFixed(2)
}


export const CheckAvailability1 = ({
                                       company,
                                       settlement,
                                       year,
                                       availabilityAmountGivingSetter
                                   }) => {
    const [areaInitialInfo, setAreaInitialInfo] = useState(0)
    const [areaDeals, setAreaDeals] = useState(0)
    const [areaOthers, setAreaOthers] = useState(0)
    const [areaDrawings, setAreaDrawings] = useState(0)
    const request = requester();

    useEffect(() => {
        if (company.split(',').length === 4) {

            Promise.all([
                request.get(`${baseUrl()}/companies-initial-info/${year}/${settlement}/${Number(company.split(',')[3].trim())}`),
                request.get(`${baseUrl()}/deals/${year}/${settlement}/${Number(company.split(',')[3].trim())}/sum`),
                request.get(`${baseUrl()}/others/${year}/${settlement}/${Number(company.split(',')[3].trim())}`),
                request.get(`${baseUrl()}/drawings/${year}/${settlement}/${Number(company.split(',')[3].trim())}/sum`)
            ])
                .then(([dataInitialInfo, dataDeals, dataOthers, dataDrawings]) => {
                    setAreaInitialInfo(dataInitialInfo)
                    setAreaDeals(dataDeals)
                    setAreaOthers(dataOthers)
                    setAreaDrawings(dataDrawings)
                })
        }
    }, [company, settlement, year])

    useEffect(() => {
        availabilityAmountGivingSetter(totalArea(areaInitialInfo, areaDeals, areaOthers, areaDrawings))
    }, [areaInitialInfo, areaDeals, areaOthers, areaDrawings])

    return (
        <>
            <div className="row g-3 align-items-center">
                <div className="col-1">
                    <p className="col-form-label">Налично:</p>
                </div>
                <div className="col-5">{totalArea(areaInitialInfo, areaDeals, areaOthers, areaDrawings)}</div>
                {!areaInitialInfo.suitable_land &&
                    <div style={{color: 'red'}}>Няма въведена информация за декларирана и годна площ!</div>}
                {areaInitialInfo.suitable_land &&
                    <div style={{color: 'blue'}}>Площта включва въведена информация за декларирана и годна площ!</div>}
                {!areaDeals.sum_deals && <div style={{color: 'red'}}>Няма въведена информация за ДЗ!</div>}
                {areaDeals.sum_deals &&
                    <div style={{color: 'blue'}}>Площта включва въведена информация за ДЗ!</div>}
                {!areaOthers.total && <div style={{color: 'red'}}>Няма въведена информация за други площи!</div>}
                {areaOthers.total &&
                    <div style={{color: 'blue'}}>Площта включва въведена информация за други площи!</div>}
                {!areaDrawings.sum_drawings &&
                    <div style={{color: 'red'}}>Няма въведена информация за изчертани площи!</div>}
                {areaDrawings.sum_drawings &&
                    <div style={{color: 'blue'}}>Площта включва въведена информация за изчертани площи!</div>}
            </div>
        </>
    )
}



// ЧАСТ К: наличността на ВЗЕМАЩАТА фирма в НАСРЕЩНОТО землище — което може да
// е чуждо (потребителят няма права да го гледа и чертае).
//
// Затова тук се вика един-единствен ендпойнт, който връща само наличната площ.
// Досега се теглеха четири справки за това землище (правно, замени, други
// площи, изчертано) и всяка е защитена по права — при чуждо село панелът просто
// щеше да гръмне. Одобрено е човекът да вижда точно това и нищо повече: дали
// насрещната фирма наистина разполага с площта, която обещава.
export const CheckAvailability2 = ({
                                       company,
                                       settlement,
                                       year,
                                       availabilityAmountTakingSetter
                                   }) => {
    const [available, setAvailable] = useState(null);
    const [loaded, setLoaded] = useState(false);
    const request = requester();

    const settlementName = settlement ? settlement.split(',')[0].trim() : '';

    useEffect(() => {
        if (company.split(',').length !== 4 || settlement.split(',').length !== 4) return;

        const ekatte = settlement.split(',')[3].trim();
        const bullstat = Number(company.split(',')[3].trim());

        setLoaded(false);
        request.get(`${baseUrl()}/deals/availability/${year}/${ekatte}/${bullstat}`)
            .then(data => {
                setAvailable(data?.available ?? null);
                setLoaded(true);
            })
            .catch(() => {
                setAvailable(null);
                setLoaded(true);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [company, settlement, year]);

    useEffect(() => {
        availabilityAmountTakingSetter(available ?? 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [available]);

    return (
        <div className="row g-3 align-items-center">
            <div className="col-2">
                <p className="col-form-label mb-0">Налично:</p>
            </div>
            <div className="col-10">
                {available !== null && <span>{available.toFixed(2)}</span>}
                {loaded && available === null && (
                    <span style={{color: "var(--app-danger-fg)"}}>
                        Няма информация за наличности в {settlementName || 'това землище'}
                    </span>
                )}
            </div>
        </div>
    );
}
